async function fetchAll () {
    return this.api({
        url: `/pages/`,
        method: 'GET'
    })
}

async function create ( page ) {
    return this.api({
        url: `/pages/`,
        method: 'POST',
        data: page
    })
}

async function edit ( id, page ) {
    return this.api({
        url: `/pages/${id}`,
        method: 'PATCH',
        data: page
    })
}

async function getBySlug ( slug ) {
    return this.api({
        url: `/pages/slug/${slug}`,
        method: 'GET'
    })
}

export default {
    pluginName: 'pages',
    methods: {
        fetchAll, create, edit,
        getBySlug
    }
}